export const ACTIVITY_STATE_NOT_STARTED = 'NotStarted';
export const ACTIVITY_STATE_IN_PROGRESS = 'InProgress';
export const ACTIVITY_STATE_COMPLETED = 'Completed';
